import UserPermissionForm from './UserPermissionForm';

export default UserPermissionForm;
